// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"070b7b59","271":"ac7cb11e","389":"90d99c0a","453":"e6c61882","732":"9c25aae7","977":"22b827e9"}[chunkId] + ".chunk.js";
};